import NotificationSlider from "./NotificationSlider";

export default NotificationSlider;
